/**
 * ParkingPayment API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ScheduleFrequency = 0 | 1 | 2 | 3;

export const ScheduleFrequency = {

    NUMBER_0: 0 as ScheduleFrequency,

    NUMBER_1: 1 as ScheduleFrequency,

    NUMBER_2: 2 as ScheduleFrequency,

    NUMBER_3: 3 as ScheduleFrequency
};

